export default __webpack_public_path__ + "static/media/app_logo_small.f502309c.png";